import Icon from '../components/Icon.vue'

Icon.register({"map-pin":{"width":320,"height":512,"paths":[{"d":"M192 300.8V473.6L170 506.7C165.2 513.8 154.8 513.8 150 506.7L128 473.6V300.8A162.2-162.2 0 0 1 192 300.8zM160 0C239.5 0 304 64.5 304 144S239.5 288 160 288 16 223.5 16 144 80.5 0 160 0M80 136C80 96.3 112.3 64 152 64A8-8 0 0 1 152 48C103.5 48 64 87.5 64 136A8-8 0 0 1 80 136z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-pin.js
// module id = oKy+
// module chunks = 0